import { gql } from "@apollo/client";

export const GET_HOMEOWNER_PROJECTS = gql`
  query GetHomeOwnerProjects($homeOwnerId: String!, $active: Boolean) {
    getHomeOwnerProjects(homeOwnerId: $homeOwnerId, active: $active) {
      _id
      homeOwnerId
      active
      status
      completionRequestedBy
      completionRequestedAt
      completionConfirmedBy
      completionConfirmedAt
      archivedAt
      projectName
      projectStartDate
      propertyType
      projectScope
      billingPreferences
      budgetRange
      specialRequirements
      furniturePreferences
      hardDeadline
      deadlineDate
      financing
      reasonForHiring
      otherReasonForHiring
      ownershipDuration
      propertyDetails
      residenceType
      propertyLocation
      squareFootage
      bedrooms
      bathrooms
      decisionMakers
      worksRemotely
      workedWithDesigner
      experience {
        rating
        notes
      }
      entertainRegularly
      hasPets
      pets {
        type
        count
      }
      hobbies
      household {
        adults
        kids
        kidsAges
      }
      wishList
      notes
      designerNotes
    }
  }
`;

export const CREATE_HOMEOWNER_PROJECT = gql`
  mutation CreateHomeOwnerProject(
    $homeOwnerId: String!
    $active: Boolean
    $status: String
    $completionRequestedBy: String
    $completionRequestedAt: String
    $completionConfirmedBy: String
    $completionConfirmedAt: String
    $projectName: String
    $projectStartDate: String
    $propertyType: String
    $projectScope: [String]
    $billingPreferences: [String]
    $budgetRange: String
    $specialRequirements: [String]
    $furniturePreferences: [String]
    $hardDeadline: Boolean
    $deadlineDate: String
    $financing: Boolean
    $reasonForHiring: String
    $otherReasonForHiring: String
    $ownershipDuration: String
    $propertyDetails: String
    $residenceType: String
    $propertyLocation: String
    $squareFootage: String
    $bedrooms: String
    $bathrooms: String
    $decisionMakers: String
    $worksRemotely: Boolean
    $workedWithDesigner: Boolean
    $experience: HomeOwnerExperienceInput
    $entertainRegularly: Boolean
    $hasPets: Boolean
    $pets: [HomeOwnerPetInput]
    $hobbies: [String]
    $household: HomeOwnerHouseholdInput
    $wishList: [String]
    $notes: String
    $designerNotes: String
  ) {
    createHomeOwnerProject(
      homeOwnerId: $homeOwnerId
      active: $active
      status: $status
      completionRequestedBy: $completionRequestedBy
      completionRequestedAt: $completionRequestedAt
      completionConfirmedBy: $completionConfirmedBy
      completionConfirmedAt: $completionConfirmedAt
      projectName: $projectName
      projectStartDate: $projectStartDate
      propertyType: $propertyType
      projectScope: $projectScope
      billingPreferences: $billingPreferences
      budgetRange: $budgetRange
      specialRequirements: $specialRequirements
      furniturePreferences: $furniturePreferences
      hardDeadline: $hardDeadline
      deadlineDate: $deadlineDate
      financing: $financing
      reasonForHiring: $reasonForHiring
      otherReasonForHiring: $otherReasonForHiring
      ownershipDuration: $ownershipDuration
      propertyDetails: $propertyDetails
      residenceType: $residenceType
      propertyLocation: $propertyLocation
      squareFootage: $squareFootage
      bedrooms: $bedrooms
      bathrooms: $bathrooms
      decisionMakers: $decisionMakers
      worksRemotely: $worksRemotely
      workedWithDesigner: $workedWithDesigner
      experience: $experience
      entertainRegularly: $entertainRegularly
      hasPets: $hasPets
      pets: $pets
      hobbies: $hobbies
      household: $household
      wishList: $wishList
      notes: $notes
      designerNotes: $designerNotes
    ) {
      _id
      homeOwnerId
    }
  }
`;

export const UPDATE_HOMEOWNER_PROJECT = gql`
  mutation UpdateHomeOwnerProject(
    $_id: ID!
    $active: Boolean
    $status: String
    $completionRequestedBy: String
    $completionRequestedAt: String
    $completionConfirmedBy: String
    $completionConfirmedAt: String
    $projectName: String
    $projectStartDate: String
    $propertyType: String
    $projectScope: [String]
    $billingPreferences: [String]
    $budgetRange: String
    $specialRequirements: [String]
    $furniturePreferences: [String]
    $hardDeadline: Boolean
    $deadlineDate: String
    $financing: Boolean
    $reasonForHiring: String
    $otherReasonForHiring: String
    $ownershipDuration: String
    $propertyDetails: String
    $residenceType: String
    $propertyLocation: String
    $squareFootage: String
    $bedrooms: String
    $bathrooms: String
    $decisionMakers: String
    $worksRemotely: Boolean
    $workedWithDesigner: Boolean
    $experience: HomeOwnerExperienceInput
    $entertainRegularly: Boolean
    $hasPets: Boolean
    $pets: [HomeOwnerPetInput]
    $hobbies: [String]
    $household: HomeOwnerHouseholdInput
    $wishList: [String]
    $notes: String
    $designerNotes: String
  ) {
    updateHomeOwnerProject(
      _id: $_id
      active: $active
      status: $status
      completionRequestedBy: $completionRequestedBy
      completionRequestedAt: $completionRequestedAt
      completionConfirmedBy: $completionConfirmedBy
      completionConfirmedAt: $completionConfirmedAt
      projectName: $projectName
      projectStartDate: $projectStartDate
      propertyType: $propertyType
      projectScope: $projectScope
      billingPreferences: $billingPreferences
      budgetRange: $budgetRange
      specialRequirements: $specialRequirements
      furniturePreferences: $furniturePreferences
      hardDeadline: $hardDeadline
      deadlineDate: $deadlineDate
      financing: $financing
      reasonForHiring: $reasonForHiring
      otherReasonForHiring: $otherReasonForHiring
      ownershipDuration: $ownershipDuration
      propertyDetails: $propertyDetails
      residenceType: $residenceType
      propertyLocation: $propertyLocation
      squareFootage: $squareFootage
      bedrooms: $bedrooms
      bathrooms: $bathrooms
      decisionMakers: $decisionMakers
      worksRemotely: $worksRemotely
      workedWithDesigner: $workedWithDesigner
      experience: $experience
      entertainRegularly: $entertainRegularly
      hasPets: $hasPets
      pets: $pets
      hobbies: $hobbies
      household: $household
      wishList: $wishList
      notes: $notes
      designerNotes: $designerNotes
    ) {
      _id
      homeOwnerId
      status
      completionRequestedBy
      completionRequestedAt
      completionConfirmedBy
      completionConfirmedAt
      archivedAt
    }
  }
`;

export const DELETE_HOMEOWNER_PROJECT = gql`
  mutation DeleteHomeOwnerProject($_id: ID!) {
    deleteHomeOwnerProject(_id: $_id)
  }
`;
